module.exports = __webpack_public_path__ + "static/media/t-rex-memorama.573c0779.svg";